import {
  apiRequest,
  createAntdFilter,
  ProcessingCircle,
  useAccount
} from "@vojomo-core/shared";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import { useEffect, useState } from "react";
import { Select, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMantineTheme } from "@mantine/core";

interface FileDataInterface {
  dataSource: any[];
}

interface DataType {
  name: string;
  type: string;
}

export const FileExplorer = () => {
  const { vojomoAccount, companyName } = useAccount();
  const [fileData, setFileData] = useState<FileDataInterface>({
    dataSource: []
  });

  const theme = useMantineTheme();
  const [loading, setLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const [firstLoad, setFirstLoad] = useState(true);
  const [years, setYears] = useState<number[]>([currentYear]);
  const [year, setYear] = useState<number | null>(currentYear);

  // Get all years
  useEffect(() => {
    apiRequest({
      subRoute: "operating",
      path: `/get_years?&member=${companyName}`,
      method: "GET"
    }).then((res) => {
      if (typeof res === "object") {
        setYears(res["years"]);
        setYear(res["years"][0]);
      }
    });
    setFirstLoad(false);
  }, [vojomoAccount]);

  // Get year / change year
  useEffect(() => {
    if (firstLoad === false) {
      setLoading(true);
      apiRequest({
        subRoute: "operating",
        path: `/get_all_files?year=${year}&member=${companyName}`,
        method: "GET"
      }).then((res) => {
        if (typeof res === "object") {
          const data: any = res;
          setFileData({ dataSource: data.dataSource });
        }
        setLoading(false);
      });
    }
  }, [year, companyName, firstLoad]);

  const columns: ColumnsType<DataType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ...createAntdFilter<DataType>("name"),
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      render: (_: any, record: any) => (
        <a href={record.url} target="_blank">
          {record.name}
        </a>
      )
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      filterSearch: true,
      sorter: (a: any, b: any) => a.type.localeCompare(b.type),
      ...createAntdFilter<DataType>("type")
    }
  ];

  return (
    <OperatingLayout pageHeader="File Explorer">
      <div className="flex flex-row items-center">
        <p className="flex font-bold mr-4">Year</p>
        <Select
          showSearch
          className="flex"
          placeholder="Select Year"
          style={{ width: 120 }}
          onChange={(value) => setYear(value)}
          options={years.map((year) => {
            return { value: year, label: year };
          })}
        />
      </div>

      {loading ? (
        <div
          style={{
            height: "70vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <ProcessingCircle color={theme.colors.darkBlue[0]} text="" />
        </div>
      ) : (
        <div style={{ height: "70vh" }}>
          <Table columns={columns} dataSource={fileData.dataSource} />
        </div>
      )}
    </OperatingLayout>
  );
};
